import React from "react";
import "../css/Workout.css";

const Workout = () => {
  return (
    <div className="workout7">

      {/* ================= HERO ================= */}
      <section className="wk7-hero">
        <h1>Training Programs</h1>
        <p>Structured. Progressive. Built for real performance.</p>
      </section>


      {/* ================= PROGRAM TYPES ================= */}
      <section className="wk7-programs">
        <h2>Our Training Systems</h2>

        <div className="prog-grid">
          <div className="prog-card">
            <h3>Strength Training</h3>
            <p>
              Progressive overload programs focused on compound lifts,
              joint integrity, and long-term power development.
            </p>
          </div>

          <div className="prog-card">
            <h3>Conditioning</h3>
            <p>
              High-output sessions improving cardiovascular capacity,
              work tolerance, and metabolic efficiency.
            </p>
          </div>

          <div className="prog-card">
            <h3>Mobility & Control</h3>
            <p>
              Controlled movement, joint range development, and recovery
              protocols to support heavy training.
            </p>
          </div>

          <div className="prog-card">
            <h3>Athletic Performance</h3>
            <p>
              Speed, agility, coordination, and explosive power training
              for competitive and recreational athletes.
            </p>
          </div>
        </div>
      </section>


      {/* ================= WEEK STRUCTURE ================= */}
      <section className="wk7-structure">
        <h2>How Training Is Structured</h2>

        <div className="structure-grid">
          <div className="structure-item">
            <span>Phase 01</span>
            <h4>Foundation</h4>
            <p>
              Movement mechanics, posture, stability, and base strength.
            </p>
          </div>

          <div className="structure-item">
            <span>Phase 02</span>
            <h4>Build</h4>
            <p>
              Progressive load increases, volume control, conditioning work.
            </p>
          </div>

          <div className="structure-item">
            <span>Phase 03</span>
            <h4>Peak</h4>
            <p>
              Performance output, intensity cycles, and capacity testing.
            </p>
          </div>

          <div className="structure-item">
            <span>Phase 04</span>
            <h4>Recover</h4>
            <p>
              Deloads, mobility resets, and adaptation optimization.
            </p>
          </div>
        </div>
      </section>


      {/* ================= SESSION BREAKDOWN ================= */}
      <section className="wk7-session">
        <h2>A Typical Session</h2>

        <div className="session-rows">
          <div className="session-row">
            <strong>Warm-Up</strong>
            <span>Mobility • Activation • Joint Prep</span>
          </div>

          <div className="session-row">
            <strong>Main Lift</strong>
            <span>Compound Strength Focus</span>
          </div>

          <div className="session-row">
            <strong>Accessory Work</strong>
            <span>Balance • Stability • Weak-Point Training</span>
          </div>

          <div className="session-row">
            <strong>Conditioning</strong>
            <span>Intervals • Circuits • Capacity Work</span>
          </div>

          <div className="session-row">
            <strong>Cooldown</strong>
            <span>Mobility • Breath • Recovery</span>
          </div>
        </div>
      </section>


      {/* ================= FOR WHO ================= */}
      <section className="wk7-for">
        <h2>Who These Programs Are For</h2>

        <div className="for-grid">
          <div className="for-card">Beginners learning proper movement</div>
          <div className="for-card">Lifters chasing strength progression</div>
          <div className="for-card">Athletes improving performance</div>
          <div className="for-card">Adults training for longevity</div>
        </div>
      </section>


      {/* ================= STATEMENT ================= */}
      <section className="wk7-statement">
        <h2>
          TRAIN WITH <span>STRUCTURE</span>
        </h2>
        <p>
          Results follow discipline — not randomness.
        </p>
      </section>

    </div>
  );
};

export default Workout;
